import type { FetcherAxiosInstance } from '../fetcher';

export const createReviewsApi = (Fetcher: FetcherAxiosInstance) => ({
  getReviews({
    productId,
    page = 1,
    sort,
    onlyWithPhoto = false,
  } = {}) {
    return Fetcher(`/reviews/${productId}`, { params: { page, sort, onlyWithPhoto } });
  },

  getReviewsInfo({ productId } = {}) {
    return Fetcher(`/reviews/info/${productId}`);
  },

  voteForReview({ reviewId, isLike, voterId }) {
    return Fetcher.post(`/reviews/vote/${reviewId}`, {
      isLike,
      voterId,
    }, {
      validateStatus(status) {
        return (status >= 200 && status < 300) || status === 422; // ответ с ошибкой уже проголосовавшего юзера
      },
    });
  },

  addReview: ({
    rating,
    fitRating,
    qualityRating,
    photoAccuracyRating,
    body,
    pros,
    cons,
    recommended,
    authorId,
    authorName,
    authorEmail,
    authorPhone,
    locationName,
    productId,
    dimensions,
    timeUsage,
    photoIds,
  } = {}) => Fetcher.post(`/reviews/${productId}`, {
    rating,
    fitRating,
    qualityRating,
    photoAccuracyRating,
    productId,
    body,
    pros,
    cons,
    recommended,
    authorId,
    authorName,
    authorEmail,
    authorPhone,
    locationName,
    dimensions,
    timeUsage,
    photoIds,
  }),

  fetchReviewsAvailability() {
    return Fetcher.get('/reviews/availability');
  },

  uploadReviewPhoto(photo) {
    return Fetcher.post('/reviews/photo/add', photo);
  },

  fetchReviewsAvailabilityForOrder(number) {
    return Fetcher.get(`/reviews/availability/order/${number}`);
  },

  fetchReviewsAvailabilityForReceipt(number) {
    return Fetcher.get(`/reviews/availability/receipt/${number}`);
  },
});
